module.exports = __webpack_public_path__ + "img/star.73257c0f.svg";